module.exports = __webpack_public_path__ + "img/section1-1.ee558627.png";